import React from 'react'

import {
  Box,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'

import { OverflowText } from '@/components/ui'

import { DeviceConfigurationT } from '../types/types'

interface DevicesMisconfiguredModalIProps {
  isOpen: boolean
  devices: DeviceConfigurationT[]
  onClose: () => void
}

export const DevicesMisconfiguredModal = ({
  isOpen,
  devices,
  onClose,
}: DevicesMisconfiguredModalIProps) => {
  return (
    <Modal
      isCentered
      isOpen={isOpen}
      motionPreset='slideInBottom'
      onClose={onClose}
      scrollBehavior='inside'
      size='xl'
    >
      <ModalOverlay />
      <ModalContent bg='white' color='black' py='6' rounded='20px'>
        <ModalCloseButton color='black' opacity={0.4} />

        <Box fontSize='20px' fontWeight={500} px='24px'>
          Doors misconfigured
        </Box>

        <ModalBody p='24px'>
          <Flex flexDir='column' gap='5px'>
            {devices.map((d) => (
              <Flex
                alignItems='center'
                border='1px solid #D5DCE4'
                borderRadius='10px'
                justifyContent='space-between'
                key={d.id}
                px='16px'
                py='8px'
              >
                <OverflowText fontSize='14px' maxW='60%' noOfLines={1}>
                  {d.name}
                </OverflowText>
                <DeviceStatus isAssociated={d.isAssociated} />
              </Flex>
            ))}
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export const DeviceStatus = ({ isAssociated }: { isAssociated: boolean }) => {
  const bgColour = '#DDDDDD'
  const textColour = '#656565'
  const deviceText = isAssociated
    ? 'Missing camera grid'
    : 'Missing device association'
  return (
    <Box
      bg={bgColour}
      border='1px solid'
      borderColor={bgColour}
      borderRadius='12px'
      color={textColour}
      fontSize='12px'
      fontWeight={500}
      p='8px'
    >
      <Text noOfLines={1}>{deviceText}</Text>
    </Box>
  )
}
